import React, { useState } from "react";
import { Box } from "@material-ui/core";

import { BHIChart, ScoreHistory, StyledGrid } from "components/simple";
import { InfoCardWrapper } from "../ScoreHistory/styled";
import { fontFamily, fontSize, spacingDefaults } from "style/constants";
import { BHIChartType } from "../BHIChart";
import { NewCycle } from "models/userAssessmentCycle";
import { PillarName } from "models/score";

interface FactorCardProps {
  cycles: NewCycle[];
  labels: string[];
  scores: number[];
  selectedCycleIndex: number;
  selectedFactor?: PillarName;
}

const OverviewCard: React.FC<FactorCardProps> = ({
  cycles,
  labels,
  scores,
  selectedCycleIndex,
  selectedFactor
}) => {
  const [chartType, setChartType] = useState<BHIChartType>(BHIChartType.Tree);
  const hasMultipleCycles = cycles.length > 1;

  return (
    <StyledGrid container>
      <StyledGrid item width="100%" textAlign="center">
        <InfoCardWrapper>
          <StyledGrid container justifyContent="space-between">
            <StyledGrid item xs={12} lg={hasMultipleCycles ? 6 : 12}>
              <Box
                fontFamily={fontFamily.secondary}
                fontSize={fontSize.large}
                margin={`0 0 ${spacingDefaults.large} 0`}
              >
                Your BrainHealth® Index {`${chartType === BHIChartType.Tree ? "Tree" : "Factors"}`}
              </Box>
              <BHIChart
                labels={labels}
                scores={scores}
                selectedFactor={selectedFactor}
                chartType={chartType}
                setChartType={setChartType}
              />
            </StyledGrid>
            {hasMultipleCycles && (
              <StyledGrid item xs={12} lg={6}>
                <Box
                  fontFamily={fontFamily.secondary}
                  fontSize={fontSize.large}
                  margin={`0 0 ${spacingDefaults.large} 0`}
                >
                  Score History
                </Box>
                <ScoreHistory cycles={cycles} selectedCycleIndex={selectedCycleIndex} />
              </StyledGrid>
            )}
          </StyledGrid>
        </InfoCardWrapper>
      </StyledGrid>
    </StyledGrid>
  );
};

export default OverviewCard;
